import { render, staticRenderFns } from "./HowItWorkdsSection.vue?vue&type=template&id=9ace3c84&scoped=true"
var script = {}
import style0 from "./HowItWorkdsSection.vue?vue&type=style&index=0&id=9ace3c84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ace3c84",
  null
  
)

export default component.exports